const updateTenants = {
  toastr: 'Tenant atualizada',
  toastr1: ' foi atualizada com sucesso',
  toastrError: 'Tenant já cadastrada',
  toastrError1: 'Insira outro nome'
};

export default updateTenants;
